
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class CreateLoading extends Vue {
    @Prop() visible!: boolean;
    @Prop() createLoadingText!: string;
    @Prop() percentage!: number;
}
